import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FtcAttributeLockUnlockService {

  constructor(private http: HttpClient) {}

  saveLockAndUnLocking(baseUrl: string, globalParams: any, tagKeys: string, lockFlag: string): Observable<any> {
    const mergedParams: any = { ...globalParams };
    mergedParams.p_tag_key = tagKeys;
    mergedParams.p_is_locked = lockFlag;
    mergedParams.process_name = 'attributes-grid-save';

    const body = new URLSearchParams();
    Object.keys(mergedParams).forEach(k => {
      if (mergedParams[k] !== undefined && mergedParams[k] !== null) {
        body.set(k, String(mergedParams[k]));
      }
    });

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=medwnk`,
      body.toString(),
      { headers, withCredentials: true }
    );
  }
}
